// extracted by mini-css-extract-plugin
module.exports = {"badgeWrapper":"Badge_badgeWrapper__2VduX","badge":"Badge_badge__2Z8U_","textBadge":"Badge_textBadge__1caY9","theme-black":"Badge_theme-black__1JIls"};